export default __webpack_public_path__ + "static/6753-78637f44ee51798f79aa2868ceed6111.jpg";